// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1T2UX","file":"styles_file__BLpiw"};